// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.paper-footer-wrapper {\n    background-color: cornflowerblue;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    text-align: center;\n    font-size: 12px;\n    position: absolute;\n    bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
